import { arrayOf, shape } from 'prop-types'

import MenuSection from 'views/components/organisms/HeaderNew/MenuSection'
import withMountPoints from 'views/enhancers/withMountPoints'

import './YourBenefits.scss'

const getBannerData = mountPoints => [
  {
    title: 'Unser Newsletter',
    imageURL:
      'https://static.shop-apotheke.com/media/content/80x80/envelope.png',
    text: 'Infos zu Angeboten - Jetzt anmelden!',
    link: mountPoints.getNewsletter(),
  },
  {
    title: 'Die SHOP APOTHEKE App',
    imageURL: 'https://static.shop-apotheke.com/media/content/80x80/mobile.png',
    text: 'Bequem bestellen und Vorteile nutzen - jetzt herunterladen!',
    link: '/lp/shop-apotheke-app/',
  },
]

const YourBenefits = ({ menuLinks, mountPoints }) => (
  <MenuSection
    sectionClassNames={'o-Your-benefits-menu-section'}
    menuLinks={menuLinks}
    boxClasses="u-padding-small--right@small-tiny"
    cardClasses="l-col--3-of-12@medium"
    titleWrapperClasses="l-col--3-of-12@medium"
    banners={getBannerData(mountPoints)}
  />
)

YourBenefits.propTypes = {
  mountPoints: shape({}).isRequired,
  menuLinks: arrayOf(shape({})).isRequired,
}

YourBenefits.defaultProps = {}

export default withMountPoints(YourBenefits)
